import React from 'react';
import PropTypes from 'prop-types';
import { get, flatten, map } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
import { SanitizeHtml, getVideoThumbnail, Image } from '@bd/bdcore-utilities';

class Gallery extends React.Component {
  constructor(props) {
    super(props);

    const increment = 20;

    this.state = {
      increment,
      limit: increment,
      section: 'photo',
      mainDropdown: false,
      collection: null,
      galleryName: null,
    };

    this.showMore = this.showMore.bind(this);
  }

  handleTabClick = event => {
    event.preventDefault();

    const section = get(event, 'target.dataset.section');

    this.setState({
      section,
    });
  }

  changePhotoCategory = (collection, galleryName) => {
    this.setState({
      collection,
      galleryName,
    });
  }

  clickedAllImages() {
    this.setState({
      mainDropdown: !this.state.mainDropdown,
      collection: null,
      galleryName: null,
    });
  }

  closeDropdownMenuItems(collection, gallery) {
    this.changePhotoCategory(collection, gallery);
    this.setState({
      mainDropdown: !this.state.mainDropdown,
    });
  }

  toggleDropdown = e => {
    e.preventDefault();

    this.setState({
      mainDropdown: !this.state.mainDropdown,
    });
  }

  closeDropdown = () => {
    this.setState({
      mainDropdown: false,
    });
  }

  showMore() {
    this.setState({
      limit: this.state.limit + this.state.increment,
    });
  }

  render() {
    const { videos, categories } = this.props;
    const { collection, galleryName, section, mainDropdown, limit } = this.state;

    let photos = flatten(map(flatten(map(categories, 'gallery')), 'images'));
    if (collection && galleryName) {
      const coll = categories.find(c => c.collection_name === collection);
      const gal = coll.gallery.find(g => g.name === galleryName);
      photos = get(gal, 'images', []);
    } else if (collection) {
      const coll = categories.find(c => c.collection_name === collection);
      photos = flatten(map(coll.gallery, 'images', []));
    }

    return (
      <div className="gallery" id="gallery">
        <div className="gallery-tabs" >
          <button
            className="gallery-tab"
            data-section="photo"
            onClick={this.handleTabClick}
          >
            Photo Gallery
          </button>
          {
            videos.length > 0 &&
            <button
              className="gallery-tab"
              data-section="video"
              onClick={this.handleTabClick}
            >
              Video Gallery
            </button>
          }
        </div>
        <div className="gallery-content">
          <div className="container">

            {
              section === 'photo' &&
              <div>
                <h3 className="underdog">{collection ? `${collection}${galleryName ? ` - ${galleryName}` : ''}` : 'All Photos'}</h3>
                <span role="button" tabIndex={0} className="btn" onClick={this.toggleDropdown}>
                  {'Choose Category'} <img src="/images/icon-triangle-white.svg" alt="Down Arrow" />
                </span>
                {
                  mainDropdown &&
                  <div className="main-gallery-link-dropdown">
                    { collection &&
                      <span
                        className="ButtonGallery"
                        role="button"
                        tabIndex={0}
                        onClick={() => this.clickedAllImages()}
                      >
                        All Images
                      </span>
                    }
                    {categories.map(item => (
                      <span
                        key={item.collection_name}
                      >
                        <span
                          className="ButtonGallery"
                          role="button"
                          tabIndex={0}
                          onClick={() =>
                            this.closeDropdownMenuItems(item.collection_name, null)
                          }
                        >
                          {item.collection_name}
                        </span>
                        <div>
                          {(item.gallery || []).map(gallery => (
                            <span
                              className="ButtonGalleryItem"
                              key={gallery.name}
                              role="button"
                              tabIndex={0}
                              onClick={() =>
                                this.closeDropdownMenuItems(item.collection_name, gallery.name)
                              }
                            >
                              {gallery.name}
                            </span>
                          ))}
                        </div>
                      </span>
                    ))}
                  </div>
                }
              </div>
            }

            {
              section === 'photo' &&
              <LightBox
                items={photos}
              >
                <ul>
                  {
                    photos.slice(0, limit).map((photo, index) => (
                      <li key={photo.contentUrl}>
                        <Image
                          src={photo.contentUrl}
                          alt=""
                          data-index={index}
                          width={500}
                          height={333}
                          exact
                        />
                      </li>
                    ))
                  }
                </ul>
              </LightBox>
            }

            {
              limit < photos.length && section === 'photo' &&
              <div style={{ textAlign: 'center' }}>
                <button className="load-more-btn" onClick={this.showMore}>Load More</button>
              </div>
            }

            {
              section === 'video' &&
              <LightBox
                items={videos.map(video => ({
                  element: (
                    <div
                      style={{
                        width: '800px',
                        maxWidth: '80%',
                        margin: '-225px auto 0 auto',
                        top: '50%',
                      }}
                      className="embed-responsive embed-responsive-16by9"
                      dangerouslySetInnerHTML={SanitizeHtml(video)}
                    />
                  ),
                }))}
              >
                <ul>
                  {
                    videos.map((video, index) => (
                      <li key={video}>
                        <Image
                          src={getVideoThumbnail(video)}
                          alt=""
                          data-index={index}
                          width={500}
                          height={333}
                          exact
                        />
                      </li>
                    ))
                  }
                </ul>
              </LightBox>
            }
          </div>
        </div>
      </div>
    );
  }
}

Gallery.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.string),
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
};
Gallery.defaultProps = {
  videos: [],
  categories: [],
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/pages/Gallery/index.js